import './index.sass';

export default () => {
  const $btn = $('.follow-button');

  $btn.on('ajax:success', function(e) {
    if (e.detail[0] && e.detail[0].follow) {
      $btn.removeClass('button--commerce').addClass('button--second').text(I18n.t('unsubscribe')).attr('data-method', 'delete').data('method', 'delete').attr('href', e.detail[0].path);
    } else {
      $btn.addClass('button--commerce').removeClass('button--second').text(I18n.t('subscribe')).attr('data-method', 'post').data('method', 'post').attr('href', e.detail[0].path);
    }
  });
}
